export default {
      id: "money_cart-usage",
      viewBox: "0 0 65 49",
      url: __webpack_public_path__ + "img/icons.svg#money_cart",
      toString: function () {
        return this.url;
      }
    }